/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Space_Members_Manage_Extra_Seats_New_TotalInputs */

const en_space_members_manage_extra_seats_new_total = /** @type {(inputs: Space_Members_Manage_Extra_Seats_New_TotalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New Total:`)
};

const de_space_members_manage_extra_seats_new_total = /** @type {(inputs: Space_Members_Manage_Extra_Seats_New_TotalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neuer Gesamtwert:`)
};

const es_space_members_manage_extra_seats_new_total = /** @type {(inputs: Space_Members_Manage_Extra_Seats_New_TotalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuevo total:`)
};

const fr_space_members_manage_extra_seats_new_total = /** @type {(inputs: Space_Members_Manage_Extra_Seats_New_TotalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nouveau total :`)
};

const nl_space_members_manage_extra_seats_new_total = /** @type {(inputs: Space_Members_Manage_Extra_Seats_New_TotalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nieuw totaal:`)
};

/** @type {(inputs: Space_Members_Manage_Extra_Seats_New_TotalInputs) => LocalizedString} */
const it_space_members_manage_extra_seats_new_total = en_space_members_manage_extra_seats_new_total;

/** @type {(inputs: Space_Members_Manage_Extra_Seats_New_TotalInputs) => LocalizedString} */
const pt_br2_space_members_manage_extra_seats_new_total = en_space_members_manage_extra_seats_new_total;

/** @type {(inputs: Space_Members_Manage_Extra_Seats_New_TotalInputs) => LocalizedString} */
const pl_space_members_manage_extra_seats_new_total = en_space_members_manage_extra_seats_new_total;

/** @type {(inputs: Space_Members_Manage_Extra_Seats_New_TotalInputs) => LocalizedString} */
const hu_space_members_manage_extra_seats_new_total = en_space_members_manage_extra_seats_new_total;

/** @type {(inputs: Space_Members_Manage_Extra_Seats_New_TotalInputs) => LocalizedString} */
const ro_space_members_manage_extra_seats_new_total = en_space_members_manage_extra_seats_new_total;

/**
* | output |
* | --- |
* | "New Total:" |
*
* @param {Space_Members_Manage_Extra_Seats_New_TotalInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const space_members_manage_extra_seats_new_total = /** @type {((inputs?: Space_Members_Manage_Extra_Seats_New_TotalInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Space_Members_Manage_Extra_Seats_New_TotalInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_space_members_manage_extra_seats_new_total(inputs)
	if (locale === "de") return de_space_members_manage_extra_seats_new_total(inputs)
	if (locale === "es") return es_space_members_manage_extra_seats_new_total(inputs)
	if (locale === "fr") return fr_space_members_manage_extra_seats_new_total(inputs)
	if (locale === "nl") return nl_space_members_manage_extra_seats_new_total(inputs)
	if (locale === "it") return it_space_members_manage_extra_seats_new_total(inputs)
	if (locale === "pt-BR") return pt_br2_space_members_manage_extra_seats_new_total(inputs)
	if (locale === "pl") return pl_space_members_manage_extra_seats_new_total(inputs)
	if (locale === "hu") return hu_space_members_manage_extra_seats_new_total(inputs)
	return ro_space_members_manage_extra_seats_new_total(inputs)
});
export { space_members_manage_extra_seats_new_total as "space.members.manage_extra_seats.new_total" }